<vl-card-title *ngIf="titleCard">
	{{ titleCard }}
</vl-card-title>
<vl-card-description *ngIf="descriptionCard">
	{{ descriptionCard }}
</vl-card-description>
